import type { CountryCode } from '@quromedical/fhir-common';
import type { PersonContact } from '@quromedical/models';
import type { PlacesAddressComponents } from '@quromedical/places';
import { compact } from '@quromedical/utils';

const findComponent = (
  addressComponents: PlacesAddressComponents[],
  name: string,
) => addressComponents.find((add) => add.types.includes(name));

const getShortName = (
  addressComponents: PlacesAddressComponents[],
  name: string,
) => {
  const component = findComponent(addressComponents, name);
  return component?.shortName;
};
const getLongName = (
  addressComponents: PlacesAddressComponents[],
  name: string,
) => {
  const component = findComponent(addressComponents, name);
  return component?.longName;
};

export const getAddressParts = (
  addressComponents: PlacesAddressComponents[],
): Partial<PersonContact> => {
  const addressCountry = getShortName(
    addressComponents,
    'country',
  ) as CountryCode;

  const addressLine1Number = getShortName(addressComponents, 'street_number');

  const addressLine1Street = getLongName(addressComponents, 'route');

  const addressLine1 = compact([addressLine1Number, addressLine1Street]).join(
    ' ',
  );

  const addressLine2 = getLongName(addressComponents, 'sublocality_level_1');

  const addressCity = getLongName(
    addressComponents,
    'administrative_area_level_2',
  );

  const addressPostalCode = getShortName(addressComponents, 'postal_code');

  const addressLines = compact([addressLine1, addressLine2]);
  return { addressCity, addressCountry, addressPostalCode, addressLines };
};
